<ng-select #select [items]="options() ?? []" [ngModel]="value()" (ngModelChange)="handleValueChange($event)"
  (close)="onClose()" bindLabel="key" bindValue="value" [placeholder]="placeholder()" [clearable]="allowClear()"
  class="dpqa-select dropdown-select" [searchable]="false">
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <div class="ng-value">
      <span class="ng-value-label"> {{ item.key }}</span>
      <span class="ng-value-icon right" (click)="reset()" aria-hidden="true"></span>
    </div>
  </ng-template>
</ng-select>
